module.exports = __webpack_public_path__ + "images/emoji/bear.ba11fde97309312f4912.png";